module.exports = __webpack_public_path__ + "img/2.c02b93fc.jpg";